var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-permis-page"},[_c('div',{staticClass:"page-title"},[_vm._v("权限管理")]),_c('pageTable',{attrs:{"col":_vm.columns,"data":_vm.list,"showPage":false,"rowHeight":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }